import React, { Component } from 'react'
import { Container, Row, Col, Button, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames';
import { inject, observer, observable } from 'mobx-react'
import DataWrapper from '../../principal/containers/DataWrapper'
import FiltroEmailFaturamento from '../components/FiltroEmailFaturamento'
import FiltroLogs from '../components/FiltroLogs'
import EmailFaturamentoStore from '../stores/EmailFaturamentoStore'
import { TabelaGrupoEmail } from '../components/TabelaGrupoEmail'
import { Link, Redirect } from "react-router-dom";
import ModalForm from '../../comum/components/ModalForm';
import FormInput from "../../comum/components/FormInput";
import LogsStore from '../stores/LogsStore';
import { TabelaLogs } from '../components/TabelaLogs';

@observer
export class AtualizacaoCadastral extends Component {


    constructor(props) {
        super(props)

        this.controller = new EmailFaturamentoStore()
        this.controllerLog = new LogsStore()
        

    }

    alterarEmail() {
        return (
            <div className="form-wrapper">


                <Container className="liberacao-cabotagem px-0" fluid>
                    <FiltroEmailFaturamento controller={this.controller} />
                    <Row>
                        <Col className="justify-content-end d-flex mb-0">
                            {this.controller.filtrado ?

                                <Button className="btn-com-bordas-primary" onClick={() => { this.controller.mostrarModalNovoEmail = true }}>
                                    Inserir Novo Email
                                </Button>
                                : ''}
                        </Col>
                    </Row>
                    <TabelaGrupoEmail controller={this.controller} />

                </Container>
            </div>
        )
    }

    exibirLogs() {
        return (
            <div className="form-wrapper">
                <Container className="liberacao-cabotagem px-0" fluid>
                <FiltroLogs controller={this.controllerLog} />
                <TabelaLogs controller={this.controllerLog} />
                </Container>
            </div>
        )
    }

    renderContent() {
        switch (this.controller.abaAtiva) {
            case 'email':
                return this.alterarEmail()
            case 'notif':
                return (
                    null 
                );
            case 'bigPic':
                return (
                    null 
                );
            case 'logs':
                return this.exibirLogs();
            default:
                null
        }
    }

    render() {
        return (
            <div>
                
                    <Container>
                        <Row>
                            <Nav tabs className="px-0 pb-3" style={{ maxWidth: 'none' }}>
                                <NavItem>
                                    <NavLink style={{ fontSize: "12px" }} className={classnames({ active: this.controller.abaAtiva === 'email' })} onClick={() => this.controller.mudarAba('email')} >
                                        Emails Faturamento
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink style={{ fontSize: "12px" }} className={classnames({ active: this.controller.abaAtiva === 'notif' })} onClick={() => this.controller.mudarAba('notif')} >
                                        Opção 2
                                    </NavLink>
                                </NavItem>
                                {!process.env.rig && <NavItem>
                                    <NavLink style={{ fontSize: "12px" }} className={classnames({ active: this.controller.abaAtiva === 'bigPic' })} onClick={() => this.controller.mudarAba('bigPic')} >
                                        Opção 3
                                    </NavLink>
                                </NavItem>
                                } */}
                                {!process.env.rig && <NavItem>
                                    <NavLink style={{ fontSize: "12px" }} className={classnames({ active: this.controller.abaAtiva === 'logs' })} onClick={() => this.controller.mudarAba('logs')} >
                                        Log de Atualizações
                                    </NavLink>
                                </NavItem>
                                }
                            </Nav>
                        </Row>
                        {
                            //this.renderContent()
                        }
                    </Container>
                

                {this.renderContent()}

            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/telas/AtualizacaoCadastral.js